import { DatePipe } from "@angular/common";
import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  TemplateRef,
  ViewChild,
} from "@angular/core";
import { Store } from "@ngrx/store";
import { ToasterService } from "angular2-toaster";
import swal from "sweetalert2";
import * as fromRootStore from "../../../reducers";
import { WorkOrderService, Combo2Service } from "../../../services/index";
import { PurchaseOrderService } from "../../../services/purchaseorder.service";
declare var google;

@Component({
  selector: "purchase-cancel-design",
  templateUrl: "purchaseCancel.html",
})
export class purchaseCancel implements OnInit {
  @Input("tabTitle") title: string;
  @Input("tabID") tabID: string;
  @Input("params") params: any;
  @Input() active = false;
  @Input() dataContext;
  @Output() tabUpdateEvent = new EventEmitter();

  selected = [];
  isLoading: boolean = false;
  selectedDesignsId: any;
  approver: string;
  isLoadMask: Promise<any>;
  selectedDlrMapList: any[];
  loadingIndicator: boolean = true;
  reorderable: boolean = true;
  saveEvent: any;

  filter = {
    po_id: "",
    po_no: "",
    groupby: "party",
    party_id: "",
    finyear: "",
    fin_id: "",
    party_name: "",
  };
  poListCancel: any = [];
  poPartyListCancel: any = [];
  page = {
    limit: 50,
    count: 0,
    offset: 0,
    orderBy: "po_det_id",
    orderDir: "ASC",
  };
  approvedList = ["Approved", "Not Approved", "All"];

  @ViewChild("snoTemplate") snoTemplate: TemplateRef<any>;
  @ViewChild("nameTemplate") nameTemplate: TemplateRef<any>;
  @ViewChild("editDeleteTemplate") editDeleteTemplate: TemplateRef<any>;

  no_of_designs: number = 0;
  tot_mtrs: number = 0;
  finyearList = [];
  columns = [];
  toggleCol = [];
  menu: any;
  reportName = "design_no";
  reportType = "Design";
  user: any;
  total_mtrs: number = 0;
  total_designs: number = 0;
  total_po: number = 0;

  agentVisible: boolean = false;
  companyInfo: any = [];
  orderList: any = [];
  designList: any = [];

  constructor(
    public store: Store<fromRootStore.State>,
    public datePipe: DatePipe,
    private woservice: WorkOrderService,
    private combo2Service: Combo2Service,
    public toasterService: ToasterService,
    private poservice: PurchaseOrderService
  ) {}

  ngOnInit(): void {
    this.finyearCombo();
    this.getColumns();
    this.toggleCol = Object.assign({}, this.columns);
  }

  getColumns() {
    if (this.filter.groupby == "design") {
      this.columns = [
        {
          prop: "selected",
          name: "",
          sortable: false,
          canAutoResize: false,
          draggable: false,
          resizable: false,
          headerCheckboxable: true,
          checkboxable: true,
          width: 30,
        },
        {
          name: "SNo",
          prop: "sno",
          minWidth: 80,
          maxWidth: 80,
          width: 80,
          headerClass: "text-center",
          sortable: false,
          cellTemplate: this.snoTemplate,
          toggle: true,
          cellClass: "text-center",
        },
        {
          name: "Design no",
          prop: "design_no",
          cellClass: "text-left",
          headerClass: "text-left",
          minWidth: 150,
          maxWidth: 150,
          width: 150,
        },
        {
          name: "Shade",
          prop: "shade1",
          cellClass: "text-left",
          headerClass: "text-left",
          minWidth: 100,
          maxWidth: 100,
          width: 100,
        },
        {
          name: "Pend.Clrs",
          prop: "pend_colors",
          cellClass: "text-left",
          headerClass: "text-left",
          minWidth: 100,
          maxWidth: 100,
          width: 100,
        },
        {
          name: "Quality",
          prop: "quality",
          headerClass: "text-left",
          cellClass: "text-left",
          minWidth: 100,
          maxWidth: 100,
          width: 100,
        },
        {
          name: "Fab type",
          prop: "type",
          headerClass: "text-left",
          cellClass: "text-left",
          minWidth: 120,
          maxWidth: 120,
          width: 120,
        },
        {
          name: "Width",
          prop: "width",
          cellClass: "text-center",
          headerClass: "text-center",
          minWidth: 90,
          maxWidth: 90,
          width: 90,
        },
        {
          name: "Rate",
          prop: "rate",
          headerClass: "text-right",
          cellClass: "text-right",
          minWidth: 80,
          maxWidth: 80,
          width: 80,
        },
        {
          name: "Sample Cut",
          prop: "sample_cut",
          headerClass: "text-center",
          cellClass: "text-center",
          minWidth: 110,
          maxWidth: 110,
          width: 110,
        },
        {
          name: "Swatch Cut",
          prop: "swatch_cut",
          headerClass: "text-center",
          cellClass: "text-center",
          minWidth: 110,
          maxWidth: 110,
          width: 110,
        },
        {
          name: "Design type",
          prop: "design_type",
          headerClass: "text-center",
          cellClass: "text-center",
          minWidth: 100,
          maxWidth: 100,
          width: 100,
        },
        {
          name: "Mtrs",
          prop: "pend_mtrs",
          headerClass: "text-right",
          cellClass: "text-right",
          minWidth: 100,
          maxWidth: 100,
          width: 100,
        }
      ];
    } else if (this.filter.groupby == "po") {
      this.columns = [
        {
          name: "SNo",
          prop: "sno",
          minWidth: 80,
          maxWidth: 80,
          width: 80,
          headerClass: "text-center",
          sortable: false,
          cellTemplate: this.snoTemplate,
          toggle: true,
          cellClass: "text-center",
        },
        {
          name: "Party Code",
          prop: "party_code",
          cellClass: "text-left",
          headerClass: "text-left",
          minWidth: 150,
          maxWidth: 150,
          width: 150,
        },
        {
          name: "Po no",
          prop: "po_no",
          cellClass: "text-left",
          headerClass: "text-left",
          minWidth: 100,
          maxWidth: 100,
          width: 100,
        },
        {
          name: "Po date",
          prop: "po_date",
          cellClass: "text-left",
          headerClass: "text-left",
          minWidth: 120,
          maxWidth: 120,
          width: 120,
        },
        {
          name: "Transport",
          prop: "transport",
          headerClass: "text-left",
          cellClass: "text-left",
          minWidth: 100,
          maxWidth: 100,
          width: 100,
        },
        {
          name: "Agent",
          prop: "agent",
          headerClass: "text-left",
          cellClass: "text-left",
          minWidth: 120,
          maxWidth: 120,
          width: 120,
        },
        {
          name: "Tot Mtrs",
          prop: "pend_mtrs",
          headerClass: "text-right",
          cellClass: "text-right",
          minWidth: 100,
          maxWidth: 100,
          width: 100,
        },
        {
          name: "Pend.Clrs",
          prop: "pend_colors",
          cellClass: "text-left",
          headerClass: "text-left",
          minWidth: 100,
          maxWidth: 100,
          width: 100,
        },
        {
          name: "Action",
          prop: "sno",
          minWidth: 135,
          maxWidth: 135,
          width: 135,
          sortable: false,
          cellTemplate: this.editDeleteTemplate,
        },
      ];
    } else if (this.filter.groupby == "party") {
      this.columns = [
        {
          name: "SNo",
          prop: "sno",
          minWidth: 80,
          maxWidth: 80,
          width: 80,
          headerClass: "text-center",
          sortable: false,
          cellTemplate: this.snoTemplate,
          toggle: true,
          cellClass: "text-center",
        },
        {
          name: "Party Code",
          prop: "party_code",
          cellClass: "text-left",
          headerClass: "text-left",
          minWidth: 150,
          maxWidth: 150,
          width: 150,
        },
        {
          name: "No of Po(s)",
          prop: "no_of_po",
          cellClass: "text-left",
          headerClass: "text-left",
          minWidth: 90,
          maxWidth: 90,
          width: 90,
        },
        {
          name: "Tot Mtrs",
          prop: "pend_mtrs",
          headerClass: "text-right",
          cellClass: "text-right",
          minWidth: 90,
          maxWidth: 90,
          width: 90,
        },
        {
          name: "Pend.Clrs",
          prop: "pend_colors",
          cellClass: "text-left",
          headerClass: "text-left",
          minWidth: 100,
          maxWidth: 100,
          width: 100,
        },
        {
          name: "Action",
          prop: "sno",
          headerClass: "text-center",
          cellClass: "text-center",
          minWidth: 90,
          maxWidth: 90,
          width: 90,
          sortable: false,
          cellTemplate: this.editDeleteTemplate,
        },
      ];
    }

    if(this.menu.param == 'report' && this.filter.groupby == "design"){
      this.columns.splice(0,1);
    }

    this.toggleCol = Object.assign({}, this.columns);

    this.pageCallback({ offset: 0 });
  }

  onOpenedFilter(): void {
    setTimeout(function () {
      $("#party_code").focus();
    }, 100);
  }

  onChangePageSize(limit) {
    this.page.limit = 10000;
    //this.getSalesinvReport();
  }

  onColumnToggle(colToShow) {
    this.columns = colToShow;
  }

  onEnterKeyPressed(nextEl: string, ind, item) {
    if ($(".swal2-container").length > 0) {
      return false;
    } else {
      let a = $(".mat-autocomplete-panel.mat-autocomplete-visible");
      a.removeClass("mat-autocomplete-visible");
      $("#" + nextEl).focus();
    }
  }

  getRowClass(event) {
    return event.rowtype == "summary" ? "summary-row" : "";
  }

  /**
   * Called whenever the user changes page
   */
  pageCallback(pageInfo: {
    count?: number;
    pageSize?: number;
    limit?: number;
    offset?: number;
  }) {
    this.page.offset = pageInfo.offset;
    this.getDesignListCancel();
  }

  /**
   * Called whenever the user changes the sort order
   */
  sortCallback(sortInfo: {
    sorts: { dir: string; prop: string }[];
    column: {};
    prevValue: string;
    newValue: string;
  }) {
    // there will always be one "sort" object if "sortType" is set to "single"
    this.page.orderDir = sortInfo.sorts[0].dir;
    this.page.orderBy = sortInfo.sorts[0].prop;
    this.getDesignListCancel();
  }

  finyearCombo() {
    let that = this;
    this.combo2Service.finyearCombo().then((res: any) => {
      that.finyearList = res.data;
      that.filter.finyear = res.data[0].finyear;
      that.filter.fin_id = res.data[0].fin_id;
      that.getPolist(that.filter.fin_id);
    });
  }
  onSelectFinyear(finyear) {
    let exists = this.finyearList.filter((el) => el.finyear == finyear);

    if (exists && exists.length > 0) {
      this.filter.fin_id = exists[0].fin_id;
      this.getPolist(this.filter.fin_id);
    }
  }

  getPolist(fin_id) {
    let params = {
      fin_id: fin_id,
    };

    let that = this;

    this.isLoadMask = this.poservice
      .getPoListCancel(params)
      .then(function (res: any) {
        that.loadingIndicator = false;
        that.poListCancel = res.data;
        that.poPartyListCancel = res.partyList;
      });
  }

  onSelectPono(po_no) {
    let exists = this.poListCancel.filter((el) => el.po_no == po_no);

    if (exists && exists.length > 0) {
      this.filter.po_id = exists[0].po_id;
    } else {
      swal("Please enter valid PO");
    }
  }

  onSelectParty(party_name) {
    let exists = this.poPartyListCancel.filter(
      (el) => el.party_name == party_name
    );

    if (exists && exists.length > 0) {
      this.filter.party_id = exists[0].party_id;
    } else {
      swal("Please enter valid party name");
    }
  }

  clearFilter(): void {
    this.designList = [];
    this.total_designs = 0;
    this.total_mtrs = 0;
    this.tot_mtrs = 0;
    this.filter = {
      po_id: "",
      po_no: "",
      groupby: this.filter.groupby,
      party_id: "",
      finyear: this.filter.finyear,
      fin_id: this.filter.fin_id,
      party_name: "",
    };

  }

  applyFilter() {
    this.getColumns();
  }
  applyFilterView(row) {
    if (this.filter.groupby == "party") {
      this.filter.groupby = "po";
      this.filter.party_id = row.party_id;
    } else if (this.filter.groupby == "po") {
      this.filter.groupby = "design";
      this.filter.po_id = row.po_id;
    }

    this.getColumns();
  }
  gobacktoffGroup() {
    if (this.filter.groupby == "po") {
      this.filter.groupby = "party";
      this.filter.party_id = "";
    }

    if (this.filter.groupby == "design") {
      if (this.selected.length > 0) {
        swal("Please deselect all before going back");
        return;
      } else {
        this.filter.groupby = "po";
        this.filter.po_id = "";
      }
    }

    this.getColumns();
  }
  getDesignListCancel(): void {
    let params = {
      start: `${this.page.offset * this.page.limit}`,
      limit: `${this.page.limit}`,
      page: "1",
      orderColumn: `${this.page.orderBy}`,
      orderDir: `${this.page.orderDir}`,
      filter: JSON.stringify(this.filter),
    };
    let that = this;
    //this.store.dispatch(new commonActions.LoadAllParty(params));
    this.isLoadMask = this.poservice
      .getDesignListCancel(params)
      .then(function (res: any) {
        that.loadingIndicator = false;
        that.page.count = res.totCnt;
        that.designList = res.data;

        that.total_mtrs = 0;
        that.total_po = 0;
        that.designList.forEach((el) => {
          that.total_mtrs += Number(el.pend_mtrs);
          that.total_po += Number(el.no_of_po);
          el.pend_mtrs = el.pend_mtrs.toFixed(2);
        });
        that.total_mtrs =
          Math.round((that.total_mtrs + Number.EPSILON) * 100) / 100;
        // that.total_designs = that.designList.length;
      });
  }

  onSelect({ selected }) {
    this.selected.splice(0, this.selected.length);
    this.selected.push(...selected);

    console.log(this.selected);

    this.tot_mtrs = 0;
    this.no_of_designs = 0;

    this.selected.forEach((el) => {
      this.tot_mtrs += Number(el.mtrs);
    });
    this.tot_mtrs = Math.round((this.tot_mtrs + Number.EPSILON) * 100) / 100;
    this.no_of_designs = this.selected.length;
  }
  getId(row) {
    return row.po_det_id;
  }
  getIdFunction() {
    return this.getId.bind(this);
  }
  onSubmitCancelPo() {
    if (this.selected.length > 0) {
      this.selectedDesignsId = [];
      this.selectedDesignsId = this.selected.map((el) => el.po_det_id);
      let that = this;
      let swalContent = "";
      let poClose = false;
      if (that.designList.length != that.selectedDesignsId.length) {
        swalContent = "Are you sure to cancel selected design(s)?";
      } else {
        swalContent = "Are you sure to cancel all designs?";
        poClose = true;
      }
      swal({
        title: swalContent,
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, Cancel it!",
        cancelButtonText: "No, want to change",
      }).then(function () {
        let params = {
          selectedDesignsId: JSON.stringify(that.selectedDesignsId),
          poClose: poClose,
          po_id: that.filter.po_id,
        };
        that.isLoading = true;
        that.loadingIndicator = true;
        that.isLoadMask = that.poservice
          .onSubmitCancelPo(params)
          .then(function (res: any) {
            that.loadingIndicator = false;
            that.isLoading = false;

            if (res.success) {
              that.selected = [];
              that.selectedDesignsId = [];
              swal("PO designs Cancelled successfully");
              that.getDesignListCancel();
              let tabObj = {
                action: "CloseTab",
                params: {},
              };
              that.tabUpdateEvent.emit(tabObj);
              let tabObj1 = {
                action: "NewTab",
                params: {
                  tabName: "PURCHASE CANCEL DESIGN",
                  title: "PURCHASE CANCEL",
                  tabParent: "TRANSACTIONS",
                  name: "PURCHASE CANCEL",
                },
              };
              that.tabUpdateEvent.emit(tabObj1);
            }
          });
      });
    } else {
      swal("Select Atleast one design");
    }
  }

}



// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/components/Purchase/purchaseCancel/purchaseCancel.ts